<template>
  <div v-if="posts.length" :class="categoryClass" class="related-posts mb-8">
    <div class="title mb-2">{{ $t('related.title') }}</div>
    <ul>
      <li v-for="(relatedPost, index) in posts" :key="index">
        <RelatedPost :post="relatedPost" />
      </li>
    </ul>
  </div>
</template>

<script>
import RelatedPost from './RelatedPost'

export default {
  components: {
    RelatedPost,
  },
  props: {
    posts: {
      type: Array,
      required: true,
    },
    categoryClass: {
      type: String,
      required: true,
    },
  },
}
</script>

<style>
@import '~components/content/widgets/RelatedPosts.css';
</style>
